import { render, staticRenderFns } from "./NsProductDetailInfo.vue?vue&type=template&id=5240bb5b&scoped=true&"
import script from "./NsProductDetailInfo.vue?vue&type=script&lang=js&"
export * from "./NsProductDetailInfo.vue?vue&type=script&lang=js&"
import style0 from "./NsProductDetailInfo.vue?vue&type=style&index=0&id=5240bb5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5240bb5b",
  null
  
)

export default component.exports